import { render, staticRenderFns } from "./DocCateRootAdd.vue?vue&type=template&id=1a30d231&scoped=true"
import script from "./DocCateRootAdd.vue?vue&type=script&lang=js"
export * from "./DocCateRootAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a30d231",
  null
  
)

export default component.exports